// import axios from "axios";
// import { default as React, useContext, useEffect, useState } from "react";
// import styled from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import UpdatePassword from "./UpdatePassword";
// import UserData from "./UserData";
// import UpdateUnitValue from "./UpdateUnitValue";
// const Container = styled.div`
//   @media (min-width: 61.313em) {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     & > div {
//       width: 30%;
//     }
//   }
// `;



// export default function Profile() {
//   const state = useContext(GlobalState);
//   const [loading, setLoading] = useState(true);
//   const [userData, setuserData] = useState(false);

//   async function fetchData(token) {
//     try {
//       const user = await axios.get(`${process.env.REACT_APP_API}/user/data`, {
//         headers: { Authorization: token[0] },
//       });

//       setuserData(user.data);
//       setLoading(false);
//     } catch (err) {
//       console.log(err);
//     }
//   }
//   useEffect(() => {
//     fetchData(state.token);
//   }, [state.token]);

//   return (
//     <Container>
//       <UserData
//         loading={loading}
//         userData={userData}
//       />
//             <UpdateUnitValue
//         loading={loading}
//         userData={userData}
//       />
//       <UpdatePassword
//         loading={loading}
//         userData={userData}
//       />

//     </Container>
//   );
// }




// import axios from "axios";
// import { default as React, useContext, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import styled from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import UpdatePassword from "./UpdatePassword";
// import UserData from "./UserData";
// import UpdateUnitValue from "./UpdateUnitValue";
// import { BackIcon } from "../../assets/icons";
// import PumpList from "./PumpData";
// import CombinedUnitPumpComponent from "./PumpData";

// const Container = styled.div`
//   @media (min-width: 61.313em) {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     & > div {
//       width: 30%;
//     }
//   }
// `;


// const RightSection = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.5rem;
// `;

// const RowSection = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: flex-start;
//   justify-content: space-between;
//   gap: 1.5rem;          /* space between the two cards */
//   width: 100%;
//   margin-top: 1rem;
//   flex-wrap: wrap;      /* makes it responsive for small screens */
// `;


// const BackIconWrapper = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   cursor: pointer;
//   &:hover {
//     border: 2px solid var(--primary);
//   }
//   @media (min-width: 61.313em) {
//     width: 55px;
//     height: 55px;
//   }
// `;

// export default function Profile() {
//     const history = useHistory();
//   const state = useContext(GlobalState);
//   const [loading, setLoading] = useState(true);
//   const [userData, setuserData] = useState(false);

//   async function fetchData(token) {
//     try {
//       const user = await axios.get(`${process.env.REACT_APP_API}/user/data`, {
//         headers: { Authorization: token[0] },
//       });
//       setuserData(user.data);
//       setLoading(false);
//     } catch (err) {
//       console.log(err);
//     }
//   }

//   useEffect(() => {
//     fetchData(state.token);
//   }, [state.token]);

// //   return (
// //     <>

// // <BackIconWrapper
// //   onClick={() => history.push("/")}
// //   style={{
// //     flexShrink: 0,
// //     marginLeft: "10rem",
// //   }}
// // >
// //   <BackIcon />
// // </BackIconWrapper>
// //     <Container>      
// //       <UserData loading={loading} userData={userData} />
// //       {/* <RightSection> */}
// //         {/* <UpdateUnitValue loading={loading} userData={userData} /> */}
// //         {/* <UpdatePassword loading={loading} userData={userData} /> */}
// //         {/* </RightSection> */}
// //         {/* <PumpList/> */}
// //         <RightSection>
// //         <CombinedUnitPumpComponent 
// //           loading={loading} 
// //           userData={userData} 
// //           orgId={userData?.org_id} 
// //         />
// //       </RightSection>
// //     </Container>
// //     </>
// //   );

// return (
//   <>
//     <BackIconWrapper
//       onClick={() => history.push("/")}
//       style={{
//         flexShrink: 0,
//         marginLeft: "10rem",
//       }}
//     >
//       <BackIcon />
//     </BackIconWrapper>

//     <Container>
//       <RowSection>
//         <UserData loading={loading} userData={userData} />
//         <CombinedUnitPumpComponent
//           loading={loading}
//           userData={userData}
//           orgId={userData?.org_id}
//         />
//       </RowSection>
//     </Container>
//   </>
// );
// }

// import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import styled from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import { BackIcon } from "../../assets/icons";
// import UserData from "./UserData";
// import CombinedUnitPumpComponent from "./PumpData";

// const PageWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   width: 100%;
// `;

// const Container = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: center;
// `;

// const Wrapper = styled.div`
//   margin-left: auto;
//   margin-right: auto;
//   margin-top: 20px;
//   margin-bottom: auto;
//   width: 90%;

//   @media (min-width: 61.313em) {
//     width: 80%;
//   }
// `;

// const RowSection = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   align-items: flex-start;
//   gap: 2rem;
//   width: 100%;
//   max-width: 1200px;
//   flex-wrap: nowrap;

//   /* Apply right shift only on big screens */
//   @media (min-width: 1200px) {
//     transform: translateX(70px);
//   }

//   @media (max-width: 900px) {
//     flex-direction: column;
//     align-items: center;
//     transform: translateX(0);
//   }
// `;

// const CardWrapper = styled.div`
//   flex: 1;
//   width: 100%;
//   max-width: 450px;

//   display: flex;
//   justify-content: center;
//   align-items: center;

//   @media (max-width: 900px) {
//     margin-top: 0;
//   }
// `;

// const BackIconWrapper = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   // margin-left: 10rem;
//   cursor: pointer;
//   &:hover {
//     border: 2px solid var(--primary);
//   }

//     @media (max-width: 600px) {  /* for small screens */
//     margin-bottom: 20px;      /* adjust as needed */
//   }
//   @media (min-width: 61.313em) {
//     width: 55px;
//     height: 55px;
//   }
// `;

// export default function Profile() {
//   const history = useHistory();
//   const state = useContext(GlobalState);
//   const [loading, setLoading] = useState(true);
//   const [userData, setUserData] = useState(null);

//   async function fetchData(token) {
//     try {
//       const user = await axios.get(`${process.env.REACT_APP_API}/user/data`, {
//         headers: { Authorization: token[0] },
//       });
//       setUserData(user.data);
//       setLoading(false);
//     } catch (err) {
//       console.log(err);
//     }
//   }

//   useEffect(() => {
//     if (state.token) fetchData(state.token);
//   }, [state.token]);

// const hasPump = userData?.some(
//   u => u.label?.toLowerCase() === "pump" && u.sensors?.length > 0
// );

// const hasBorewell = userData?.some(
//   u => u.label?.toLowerCase() === "borewell" && u.sensors?.length > 0
// );


// console.log("UNITS ===>", userData?.units);

//   return (
//    <Wrapper>
//    <div
//     style={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     // gap: "1rem",
//     width: "100%",
//    }}
//       >
//       <BackIconWrapper onClick={() => history.push("/")}>
//         <BackIcon />
//       </BackIconWrapper>
//       </div>

//     <PageWrapper>
//       <Container>
//         <RowSection>
//           <CardWrapper>
//             <UserData loading={loading} userData={userData} />
//           </CardWrapper>
//           <CardWrapper > 
//             <CombinedUnitPumpComponent
//               loading={loading}
//               userData={userData}
//               orgId={userData?.org_id}
//             />
//           </CardWrapper>
//           {/* {(hasPump || hasBorewell) && (
//         <CardWrapper>
//           <CombinedUnitPumpComponent
//             loading={loading}
//             userData={userData}
//             orgId={orgId}
//           />
//         </CardWrapper>
//       )} */}


//         </RowSection>
//       </Container>
//     </PageWrapper>
//     </Wrapper>
//   );
// }



import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import { BackIcon } from "../../assets/icons";
import UserData from "./UserData";
import CombinedUnitPumpComponent from "./PumpData";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: auto;
  width: 90%;

  @media (min-width: 61.313em) {
    width: 80%;
  }
`;

const RowSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  // gap: 1rem;
  width: 100%;
  max-width: 1200px;
  flex-wrap: nowrap;

  @media (min-width: 1200px) {
    transform: translateX(70px);
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    transform: translateX(0);
  }
`;

const CardWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 450px;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    margin-top: 0;
  }
`;

const BackIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    border: 2px solid var(--primary);
  }

  @media (max-width: 600px) {
    margin-bottom: 20px;
  }
  @media (min-width: 61.313em) {
    width: 55px;
    height: 55px;
  }
`;

export default function Profile() {
  const history = useHistory();
  const state = useContext(GlobalState);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  async function fetchData(token) {
    try {
      const user = await axios.get(`${process.env.REACT_APP_API}/user/data`, {
        headers: { Authorization: token[0] },
      });

      setUserData(user.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (state.token) fetchData(state.token);
  }, [state.token]);

  const units = userData?.units || [];

 const hasPump = userData?.units?.some(
  u => u.label?.toLowerCase() === "pump" && u.sensors && u.sensors.length > 0
);

const hasBorewell = userData?.units?.some(
  u => u.label?.toLowerCase() === "borewell" && u.sensors && u.sensors.length > 0
);
  return (
    <Wrapper>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <BackIconWrapper onClick={() => history.push("/")}>
          <BackIcon />
        </BackIconWrapper>
      </div>

      <PageWrapper>
        <Container>
          <RowSection>
            <CardWrapper>
              <UserData loading={loading} userData={userData} />
            </CardWrapper>

              <CardWrapper>
                <CombinedUnitPumpComponent
                  loading={loading}
                  userData={userData}
                  orgId={userData?.org_id}
                />
              </CardWrapper>
          </RowSection>
        </Container>
      </PageWrapper>
    </Wrapper>
  );
}
